const UserRole = Object.freeze({
  Admin: "admin",
  Assistant: "assistant",
  Client: "client",
});

export default UserRole;
